import useMessageWebview from '@/hooks/useMessageWebview';
import React from 'react';

const MessagingHandle = (props: any) => {
  useMessageWebview();

  return <>{props.children}</>;
};

export default MessagingHandle;
